
import JSZip from '../../node_modules/jszip/dist/jszip'
import { saveAs } from '../../node_modules/file-saver/dist/FileSaver';

document.addEventListener("DOMContentLoaded", () => {
  const products = window.developerPortal.paymentProducts;
  const btn = document.querySelector('#download-logo-zip')

  const countProducts = products.length
  let counter = 0;

  btn.addEventListener('click', function () {
    let zip = new JSZip();

    btn.setAttribute('disabled', 'disabled')

    products.forEach(async p => {
      const imgData = await getBase64FromUrl(p.logo)
      const name = p.name.replace(" ", "-").replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').toLowerCase()
      zip.file(`${name}.png`, imgData, { base64: true });
      counter++

      //all logos added
      if (counter === countProducts) {
        generateAndDownloadZip(zip, btn);
      }
    });
  })
});

function generateAndDownloadZip(zip, btn) {
  zip.generateAsync({ type: "blob" })
    .then(function (content) {
      saveAs(content, "Worldline-paymentmethod-logos.zip");
      btn.removeAttribute('disabled')
    });
}

const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      base64data = base64data.split(',')
      resolve(base64data[1]);
    }
  });
}